var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnnouncement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53906 16.8844L11.0291 22.9244L13.4591 21.5244L10.1091 15.7344",
    stroke: "#343B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8885 1.72341L19.6685 13.4534C20.0185 14.0634 19.8185 14.8334 19.2085 15.1834C18.5985 15.5334 17.8285 15.3334 17.4785 14.7234L17.3585 14.5134C17.0785 14.0334 13.2785 14.6534 10.1285 15.7334C9.4785 15.9634 8.8485 16.2034 8.2885 16.4634L6.3085 17.6034C5.8185 17.8934 5.1985 17.7234 4.9185 17.2334L2.2585 12.6134C1.9785 12.1234 2.1385 11.5034 2.6285 11.2234L4.6085 10.0834C7.5485 8.00341 11.1685 3.78341 10.8285 3.20341L10.7085 2.99341C10.3585 2.38341 10.5685 1.61341 11.1685 1.26341C11.7785 0.913409 12.5485 1.12341 12.8985 1.72341H12.8885Z",
    stroke: "#343B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4081 8.75488C18.1681 8.31488 18.4281 7.35488 17.9881 6.59488C17.5481 5.83488 16.5881 5.57488 15.8281 6.01488",
    stroke: "#343B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1289 4.23531L19.3189 1.94531",
    stroke: "#343B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6992 5.61641L21.4992 4.56641",
    stroke: "#343B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1211 7.66797L22.7011 7.76797",
    stroke: "#343B1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.56938 13.2031L4.54938 16.6431L3.66938 17.1531C3.30938 17.3631 2.82938 17.2431 2.61938 16.8731L1.40938 14.7731C1.19938 14.4131 1.32938 13.9331 1.68938 13.7231L2.56938 13.2131V13.2031Z",
    stroke: "#343B1B",
    strokeWidth: 0.89,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.dfadb37f1b927d19ec28c0320fb0027f.svg";
export { ForwardRef as ReactComponent };